// extracted by mini-css-extract-plugin
module.exports = {"pipelineDetailsRow":"review_pipelineDetailsRow__3agdV","rowSubTitle":"review_rowSubTitle__3yjpD","rowValues":"review_rowValues__2coDl","actionBtns":"review_actionBtns__2U8-8"};